import ProductTable from './productTable.component';

export default ProductTable;